import {
  IGCPRequestState,
  ISuggestedFlightMarker,
} from "../../modules/gcpRequest/reducer";
import { IFlightMarkersState } from "../../modules/flightMarkers/flightMarkersReducer";
import { getNextNailNumber } from "../../modules/flightMarkers/utils";
import { IInitialGCPRequestState } from "../../modules/initialGCPRequest/initialGcpRequestReducer";
import { IInitialGcpRequestSuggestedFlightMarker } from "../../../apiFacades/bapi/initialGcpRequest";
import currentGcpRequestStore from "../../../react/ModeCurrentGCPRequest/currentGCPRequestStore";
import { SuggestedGcpType } from "../../../apiFacades/bapi/gcpRequests";

export interface INamedFlightMarker<T> {
  name: string;
  type?: SuggestedGcpType;
  flightMarker: T;
}

function getNamedGcpRequestFlightMarkersList(
  gcpRequestState: IGCPRequestState,
  flightMarkersState: IFlightMarkersState,
  mixInstalled: boolean,
): Array<INamedFlightMarker<ISuggestedFlightMarker>> {
  const { suggestedGcpsNames, GCPRequest } = currentGcpRequestStore.getState();

  return gcpRequestState.suggestedFlightMarkers
    .map((suggestedFlightMarker) => {
      const installedMarker = gcpRequestState.installedFlightMarkers.find(
        (marker) => marker.id === suggestedFlightMarker.id,
      );
      const name = suggestedGcpsNames[suggestedFlightMarker.id];
      // the first two optional operators were added because of tests
      const type = GCPRequest?.suggested?.find(
        (marker) => marker.id === suggestedFlightMarker.id,
      )?.type;

      return {
        name,
        type,
        flightMarker:
          mixInstalled && installedMarker
            ? installedMarker
            : suggestedFlightMarker,
      };
    })
    .sort((marker1, marker2) => {
      if (marker1.type == null || marker2.type == null) {
        return +Boolean(marker1.type) - +Boolean(marker2.type);
      }
      return marker1.type.localeCompare(marker2.type);
    });
}

export const getNamedGcpRequestSuggestedFlightMarkers = (
  gcpRequestState: IGCPRequestState,
  flightMarkersState: IFlightMarkersState,
): Array<INamedFlightMarker<ISuggestedFlightMarker>> =>
  getNamedGcpRequestFlightMarkersList(
    gcpRequestState,
    flightMarkersState,
    false,
  );

export const getNamedGcpRequestFlightMarkers = (
  gcpRequestState: IGCPRequestState,
  flightMarkersState: IFlightMarkersState,
): Array<INamedFlightMarker<ISuggestedFlightMarker>> =>
  getNamedGcpRequestFlightMarkersList(
    gcpRequestState,
    flightMarkersState,
    true,
  );

const getNamedInitialGcpRequestFlightMarkersList = (
  initialGcpRequestState: IInitialGCPRequestState,
  flightMarkersState: IFlightMarkersState,
  mixInstalled: boolean,
): Array<INamedFlightMarker<IInitialGcpRequestSuggestedFlightMarker>> => {
  const nextFlightMarkerNumber =
    flightMarkersState.data && flightMarkersState.data.nails
      ? getNextNailNumber(flightMarkersState.data.nails)
      : 1;
  return initialGcpRequestState.data.suggestedFlightMarkers.map(
    (suggestedFlightMarker, index) => {
      const installedMarker =
        initialGcpRequestState.data.installedFlightMarkers.find(
          (marker) => marker.id === suggestedFlightMarker.id,
        );
      return {
        flightMarker:
          mixInstalled && installedMarker
            ? installedMarker
            : suggestedFlightMarker,
        name: `${index + nextFlightMarkerNumber}`,
      };
    },
  );
};

/*
 * @deprecated use getPotentialFlightMarkersForInitialGcpRequest
 */
export const getNamedInitialGcpRequestSuggestedFlightMarkers = (
  initialGcpRequestState: IInitialGCPRequestState,
  flightMarkersState: IFlightMarkersState,
): Array<INamedFlightMarker<IInitialGcpRequestSuggestedFlightMarker>> =>
  getNamedInitialGcpRequestFlightMarkersList(
    initialGcpRequestState,
    flightMarkersState,
    false,
  );

/*
 * @deprecated use getPotentialFlightMarkersForInitialGcpRequest
 */
export const getNamedInitialGcpRequestFlightMarkers = (
  initialGcpRequestState: IInitialGCPRequestState,
  flightMarkersState: IFlightMarkersState,
): Array<INamedFlightMarker<IInitialGcpRequestSuggestedFlightMarker>> =>
  getNamedInitialGcpRequestFlightMarkersList(
    initialGcpRequestState,
    flightMarkersState,
    true,
  );
